// extracted by mini-css-extract-plugin
module.exports = {"miniTitle":"SmallWrapper_miniTitle__NJz8g","smallWrapper":"SmallWrapper_smallWrapper__wldpx"};